<template lang="html">
  <div class="spinner">
    <div class="wheel">

    </div>
  </div>
</template>

<script>
export default {
  name: 'spinner'
}
</script>

<style lang="css">
.spinner{
    width: 100%;
    height: 100vh;
    position: fixed;
    content: "";
    top: 0;
    left: 0;
    z-index:9999;
    opacity: 1;
    -webkit-transition: all 1s ease;
    -o-transition: all 1s ease;
    transition: all 1s ease;
    background-color: #fff;
}
.wheel {
    width: 55px;
    height: 55px;
    margin: 40vh auto;
    border-right: 1px solid #263379;
    border-left: 1px solid rgba(38,51,121,.2);
    border-top: 1px solid rgba(38,51,121,.2);
    border-bottom: 1px solid rgba(38,51,121,.2);
    border-radius: 50%;
    opacity: 1;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0)
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modular/spinner.vue